import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToVideo = () => {
    document.getElementById('vsl-video')?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  };
  return <section className="py-24 bg-charcoal" data-id="element-35">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-37">
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-tight mb-8" data-id="element-38">
            NTY isn't for everyone. If you're ready to work, ready to grow, and
            ready to do something that actually matters — apply.
          </h2>

          <button onClick={scrollToVideo} className="px-12 py-5 bg-maroon text-white font-bold text-xl rounded hover:bg-opacity-90 transition-colors mb-6" data-id="element-39">
            Finish video to see apply link
          </button>

          <p className="text-gray-400 text-sm italic mb-10" data-id="element-40">
            The application link is revealed at the end of the founder's video.
            Someone from the NTY team will reach out within 48 hours of
            applying.
          </p>

          <div className="pt-8 border-t border-gray-800 space-y-4 text-left" data-id="element-41">
            <p className="text-xs text-gray-500 leading-relaxed max-w-4xl mx-auto text-center" data-id="element-42">
              <strong className="text-gray-400" data-id="element-43">Income Disclaimer:</strong> Any
              earnings or income statements made by NTY Windows or its
              representatives, including individual rep results referenced on
              this page, are estimates of what we believe you could potentially
              earn. There is no guarantee that you will achieve these levels of
              income. All earnings figures referenced reflect past performance
              of specific individuals and do not constitute a representation,
              warranty, or guarantee of your future results. Field
              representative compensation is commission-based with no minimum
              guaranteed income. Actual results vary based on individual effort,
              skill, work ethic, market conditions, and other factors outside of
              our control.
            </p>
            <p className="text-center text-gray-500 text-sm" data-id="element-44">
              &copy; {new Date().getFullYear()} NTY Windows. All rights
              reserved.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}